export const mailroomKeys = {
  FETCH_MAILROOMS: 'FETCH_MAILROOMS',
  FETCH_MAILS: 'FETCH_MAILS',
};
